import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
  selector: '[bsAutoSize]',
})
export class UiAutoSizeDirective implements AfterViewInit {
  constructor(private readonly elementRef: ElementRef<HTMLDivElement>) {}
  height$ = new BehaviorSubject<{
    height: number;
    elementRef: ElementRef<HTMLDivElement>;
  }>(0 as any);

  ngAfterViewInit(): void {
    new ResizeObserver((mutations) => {
      this.height$.next({
        height: this.elementRef.nativeElement.offsetHeight,
        elementRef: this.elementRef,
      });
    }).observe(this.elementRef.nativeElement);
    new MutationObserver((mutations) => {
      const element = mutations[0].target as HTMLElement;
      if (element.children.length === 0) {
        this.height$.next({ height: 1, elementRef: this.elementRef });
      }
    }).observe(this.elementRef.nativeElement, {
      childList: true,
      attributes: true,
    });
  }
}
